export default class Summary
{
  constructor(id, isActive, dayOfWeek, hour, emails) 
  {
    this.id = id;
    this.isActive = isActive;
    this.dayOfWeek = dayOfWeek;
    this.hour = hour ? hour.split(':')[0] : null;
    this.emails = emails ? emails.replace(" ", "").split(",") : [];
  }    
}